exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "figure,figure img,figure video{max-width:100%}.dropzone h5{padding:15px;text-align:center;max-width:90%}.dropzone h5 span{margin-top:15px;display:block;font-size:12px}.dropzone h5 span strong{text-transform:uppercase}", ""]);

